module.exports = __webpack_public_path__ + "img/icon-report-light.14807544.svg";